<template>
  <div class="famous">
    <Item v-for="(item,index) in List"
          :key="index"
          :data="item"></Item>
    <div class="other">王甲午 石玉霞 张志忠 薛五琪 陈玉才 楚恒群 王桂榕 吴爱华 李恬 李国威 沈震岐 张一华 刘晋财 唐兴尧 胡琳 李铭 刘钰泉 邵士琏 余长风 杨国城 宋殿佐 安建邦 聂铁屏 熊开敏 李开明
    </div>
    <div class="summary">
      除以上病案名人外，在病案事业崛起之初，涌现了一大批病案能人，他们用自己的力量推动着病案事业的前进和发展，他们是一代病案人的榜样和楷模，向他们致敬！
    </div>
  </div>
</template>

<script>
import { Vue, Component } from "vue-property-decorator"
import Item from "@/components/famous/item.vue"
import { FamousItem } from "./interface"
import { data } from "./data"

@Component({
  components: {
    Item
  }
})
export default class Famous extends Vue {
  List = data;
}
</script>

<style lang="scss" scoped>
.famous {
  padding: 0 58px;
  background-color: #f1f1f1;
  .other {
    padding: 40px 0;
    font-size: 16px;
    font-weight: bold;
    text-align: left;
    color: #404040;
    word-spacing: 8px;
    line-height: 24px;
  }
  .summary {
    text-align: left;
    line-height: 24px;
    margin-bottom: 50px;
  }
  // div
}
</style>